import controller from './header-button.controller';
import template from './header-button.html';
import './header-button.scss';

export default {
	template,
	controller,
	controllerAs: '$ctrl',
};
